import { handleActions } from 'redux-actions';
import {
  getNextOverviewStep,
  getPrevOverviewSteps,
} from '../../../shared/helpers';

import { initialState as onboardingInitialState } from './../Onboarding/initialState';

const mapQuestions = overviewStep =>
  onboardingInitialState[overviewStep].onboardingSteps.map(({ key, name }) => ({
    key,
    name,
    answer: '',
  }));

const overviewStepsItems = [
  {
    key: 'basic_information',
    title: 'Basic Information',
  },
  {
    key: 'project_materials',
    title: 'Project Materials',
  },
  {
    key: 'additional_requirements',
    title: 'Additional Requirements',
  },
  {
    key: 'submit',
    title: 'Submit',
  },
];

const overviewSteps = overviewStepsItems.map((step, index) => ({
  ...step,
  number: index + 1,
  status: index === 0 ? 'current' : 'empty',
  questions: mapQuestions(step.key),
}));

export const initialState = {
  currentStep: 'basic_information',
  isFetching: false,
  overviewSteps,
  selectedValues: [[], [], [], []],
};

const productionKey = 'production';
const animationKey = 'animation';

const overview = handleActions(
  {
    SELECT_PROJECT: (state, action) => {
      const selectedProject = action.payload.selected_project;

      if (selectedProject) {
        const { project_onboarding_infos: onboardingInfo } = selectedProject;

        const basicRequirements = onboardingInfo.find(
          info => info.question.key === 'basic_requirements',
        );

        const { question_response: selectedValue } = basicRequirements;

        const cardDoneIndexes = [];
        getPrevOverviewSteps(selectedProject.current_overview_step).map(step =>
          cardDoneIndexes.push(
            state.overviewSteps.findIndex(elem => elem.key === step),
          ),
        );

        const cardCurrentIndex = state.overviewSteps.findIndex(
          elem => elem.key === selectedProject.current_overview_step,
        );

        const overviewState = {
          ...state,
          currentStep: selectedProject.current_overview_step,
          isFetching: false,
          overviewSteps: state.overviewSteps.map((content, i) => {
            if (cardDoneIndexes.includes(i)) {
              return { ...content, status: 'done' };
            }
            if (i === cardCurrentIndex) {
              return { ...content, status: 'current' };
            }
            return { ...content, status: 'empty' };
          }),
        };

        const basicInformation = state.overviewSteps.find(
          step => step.key === 'basic_information',
        );

        return {
          ...overviewState,
          overviewSteps: [
            ...overviewState.overviewSteps.filter(
              step => step.key !== 'basic_information',
            ),
            {
              ...basicInformation,
              questions: basicInformation.questions.map(question => {
                if (![productionKey, animationKey].includes(question.key)) {
                  return question;
                }

                if (question.key === productionKey) {
                  return {
                    ...question,
                    disabled: !selectedValue.includes(productionKey),
                  };
                }

                if (question.key === animationKey) {
                  return {
                    ...question,
                    disabled: !selectedValue.includes(animationKey),
                  };
                }
                return null;
              }),
            },
          ].sort((step1, step2) => step1.number - step2.number),
        };
      }

      return Object.assign({}, state, {
        isFetching: false,
      });
    },

    SELECT_PROJECT_REQUEST: state =>
      Object.assign({}, state, {
        isFetching: true,
      }),

    SET_NEXT_OVERVIEW_STEP: (state, action) => {
      const cardDoneIndex = state.overviewSteps.findIndex(
        elem => elem.key === action.payload.overviewStep,
      );
      const cardCurrentIndex = state.overviewSteps.findIndex(
        elem => elem.key === getNextOverviewStep(action.payload.overviewStep),
      );

      return {
        ...state,
        currentStep: getNextOverviewStep(action.payload.overviewStep),
        overviewSteps: state.overviewSteps.map((content, i) => {
          if (i === cardDoneIndex) {
            return { ...content, status: 'done' };
          }
          if (i === cardCurrentIndex) {
            return { ...content, status: 'current' };
          }
          return content;
        }),
      };
    },

    SET_CURRENT_OVERVIEW_STEP: (state, action) => ({
      ...state,
      currentStep: action.payload.currentStep,
    }),

    SELECT_STEP_VALUE: (state, action) => {
      const { data: currentStep, selectedValue } = action.payload;

      const basicInformation = state.overviewSteps.find(
        step => step.key === 'basic_information',
      );

      return {
        ...state,
        overviewSteps: [
          ...state.overviewSteps.filter(
            step => step.key !== 'basic_information',
          ),
          {
            ...basicInformation,
            questions: basicInformation.questions.map(question => {
              const isCheckableStep = ![productionKey, animationKey].includes(
                question.key,
              );

              if (currentStep !== 'basic_requirements' || isCheckableStep) {
                return question;
              }

              if (question.key === productionKey) {
                return {
                  ...question,
                  disabled: !selectedValue.includes(productionKey),
                };
              }

              if (question.key === animationKey) {
                return {
                  ...question,
                  disabled: !selectedValue.includes(animationKey),
                };
              }
              return null;
            }),
          },
        ].sort((step1, step2) => step1.number - step2.number),
      };
    },
    AUTHENTICATION_LOGOUT: () => ({
      ...initialState,
    }),
  },
  initialState,
);

export default overview;



// WEBPACK FOOTER //
// ./src/store/reducers/Overview/index.js